import { getCookie } from 'cookies-next';
import { useEffect, useState } from 'react';

export const useStaticCookies = () => {
  const [cookieConsent, setCookieConsent] = useState(
    getCookie('cookiePreferences')
  );
  useEffect(() => {
    let inter: number | undefined;
    const checkInterval = () => {
      const cookie = getCookie('cookiePreferences');
      if (cookie) {
        setCookieConsent(cookie);
        window.clearInterval(inter);
      }
      return;
    };
    if (typeof window !== 'undefined' && !cookieConsent) {
      inter = window.setInterval(checkInterval, 500);
    }
  }, []); //eslint-disable-line
  return { cookieConsent };
};
